import Vue from 'vue';
import router from '../router';

export default {
  init() {
    this.setHeaders();
    Vue.axios.interceptors.response.use(response => {
      return response && response.data;
    }, error => {
      console.log(error);
      const status = error.response.status;
      if (status && /4\d\d/.test(status)) {
        switch (status) {
        case 404:
          console.error('404 Not Found!');
          break;
        case 401:
          console.error('401 error!');
          router.push('/logon');
          break;
        default:
          console.error('出错啦，请稍后再试');
        }
        return Promise.reject(error.response);
      }
      if (status === 0) {
        console.error('ajax timeout error: 网络不给力，数据请求超时，请稍后再试');
        router.push('/error');
        return Promise.reject(error.response);
      }
      if (status === 502) {
        console.error('ajax timeout error: 网络不给力，数据请求超时，请稍后再试');
        return Promise.reject(error.response);
      }
      if (status === 504) {
        console.error('ajax timeout error: 网络不给力，数据请求超时，请稍后再试');
        router.push('/error');
        return Promise.reject(error.response);
      }
      return Promise.reject(error.response);
    });
  },

  setHeaders() {
    Vue.axios.defaults.timeout = 1000 * 5 * 60;
    Vue.axios.defaults.headers['client-type'] = 'user-dashboard';
  }
};
